module.exports = __webpack_public_path__ + "img/bootstrap.6a74ea21.png";